Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useAnimatedRef = useAnimatedRef;
var _react = require("react");
var _useSharedValue = require("./useSharedValue");
var _fabricUtils = require("../fabricUtils");
var _shareables = require("../shareables");
var _reactNative = require("react-native");
function getComponentOrScrollable(component) {
    if (global._IS_FABRIC && component.getNativeScrollRef) {
        return component.getNativeScrollRef();
    } else if (!global._IS_FABRIC && component.getScrollableNode) {
        return component.getScrollableNode();
    }
    return component;
}
var getTagValueFunction = global._IS_FABRIC ? _fabricUtils.getShadowNodeWrapperFromRef : _reactNative.findNodeHandle;
var _worklet_10709902486534_init_data = {
    code: "function anonymous(){const{tag,viewName}=this.__closure;const f=function(){return tag.value;};f.viewName=viewName;return f;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedRef.ts",
    sourceMap: '{"version":3,"names":["anonymous","tag","viewName","__closure","f","value"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useAnimatedRef.ts"],"mappings":"AA4Dc,SAAAA,SAAMA,CAAA,QAAAC,GAAA,CAAAC,QAAA,OAAAC,SAAA,CAEZ,KAAM,CAAAC,CAAC,CAAG,QAAAA,CAAA,QAAM,CAAAH,GAAG,CAACI,KAAK,GACzBD,CAAC,CAACF,QAAQ,CAAGA,QAAQ,CACrB,MAAO,CAAAE,CAAC,CACV"}',
    version: "3.5.4"
};
function useAnimatedRef() {
    var tag = (0, _useSharedValue.useSharedValue)(-1);
    var viewName = (0, _useSharedValue.useSharedValue)(null);
    var ref = (0, _react.useRef)();
    if (!ref.current) {
        var fun = function fun(component) {
            if (component) {
                tag.value = getTagValueFunction(getComponentOrScrollable(component));
                fun.current = component;
                if (_reactNative.Platform.OS === "ios" && !global._IS_FABRIC) {
                    var _component$viewConfig;
                    viewName.value = (component == null ? void 0 : (_component$viewConfig = component.viewConfig) == null ? void 0 : _component$viewConfig.uiViewClassName) || "RCTView";
                }
            }
            return tag.value;
        };
        fun.current = null;
        var remoteRef = (0, _shareables.makeShareableCloneRecursive)({
            __init: function() {
                var _e = [
                    new global.Error(),
                    -3,
                    -27
                ];
                var anonymous = function anonymous() {
                    var f = function f() {
                        return tag.value;
                    };
                    f.viewName = viewName;
                    return f;
                };
                anonymous.__closure = {
                    tag: tag,
                    viewName: viewName
                };
                anonymous.__initData = _worklet_10709902486534_init_data;
                anonymous.__workletHash = 10709902486534;
                anonymous.__stackDetails = _e;
                return anonymous;
            }()
        });
        (0, _shareables.registerShareableMapping)(fun, remoteRef);
        ref.current = fun;
    }
    return ref.current;
}
